import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AssociatedOrganizationsField } from "src/components/EntityForm";
import { ProductFormProductCompany } from "src/pages/Product/ProductForm/ProductForm.types";

interface AssociatedStructuresFieldV2Props {
    ownedBy: { "@id": string; id: number; name: string } | null;
    value: ProductFormProductCompany[];
    onChange: (companies: ProductFormProductCompany[]) => void;
}

export const AssociatedStructuresFieldV2: FC<AssociatedStructuresFieldV2Props> = ({ ownedBy, value, onChange }) => {
    const { t } = useTranslation();
    const organizations = value.flatMap((association) =>
        association.organization.id === ownedBy?.id ? [] : [association.organization],
    );

    return (
        <AssociatedOrganizationsField
            organizations={organizations}
            excludedOrganizationIds={ownedBy ? [ownedBy.id] : []}
            hierarchyRootId={ownedBy?.id}
            label={t("product.v2.organization.associated_entities", "Associated entities:")}
            helperText={t(
                "product.v2.organization.associated_entities_help",
                "Select the companies involved in the product’s manufacturing so that they can complete its questionnaire and access its data.",
            )}
            placeholder={t("product.v2.organization.add_associated_entity", "Add an Associated entity")}
            removeLabel={(organization) =>
                t("product.v2.organization.remove_associated_entity", "Remove {{name}}", {
                    name: organization.name,
                })
            }
            onAdd={(newOrganizations) =>
                onChange([...value, ...newOrganizations.map((organization) => ({ organization }))])
            }
            onRemove={(organizationId) =>
                onChange(value.filter((association) => association.organization.id !== organizationId))
            }
        />
    );
};
